import React from "react";
import { Box, Typography } from "@mui/material";
import { LUXURY } from "data/guestLuxuryTheme";

const SectionHeader = ({ title, actionLabel = "View all", onAction }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      mb: 1.15,
    }}
  >
    <Typography
      sx={{
        fontFamily: LUXURY.displayFont,
        fontWeight: 500,
        fontSize: "1.28rem",
        lineHeight: 1.15,
        color: LUXURY.ink,
      }}
    >
      {title}
    </Typography>
    {onAction ? (
      <Box
        component="button"
        type="button"
        onClick={onAction}
        sx={{
          appearance: "none",
          border: 0,
          bgcolor: "transparent",
          color: LUXURY.gold,
          fontWeight: 600,
          fontSize: "0.78rem",
          letterSpacing: 0.2,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: 0.35,
          flexShrink: 0,
          fontFamily: LUXURY.bodyFont,
          WebkitTapHighlightColor: "transparent",
        }}
      >
        {actionLabel}
        <Box component="span" sx={{ fontSize: "0.9rem", lineHeight: 1 }}>
          ›
        </Box>
      </Box>
    ) : null}
  </Box>
);

export default SectionHeader;
